import React, { createContext, useEffect, useState } from 'react';
// data
import { getRoomData } from '../data';
import { useTranslation } from 'react-i18next';
// create context
export const RoomContext = createContext();

const RoomProvider = ({ children }) => {
  const { t } = useTranslation();
  const [rooms, setRooms] = useState([]);
  const [adults, setAdults] = useState(1);
  const [kids, setKids] = useState(0);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setRooms(getRoomData(t));
  }, [t]);

  useEffect(() => {
    setTotal(Number(adults) + Number(kids));
  }, [adults, kids]);

  const handleClick = (e) => {
    e.preventDefault();
    setLoading(true);
    // filter rooms based on total (person)
    const newRooms = rooms.filter((room) => {
      return total <= room.maxPerson;
    });
    setTimeout(() => {
      setRooms(newRooms);
      setLoading(false);
    }, 3000);
  };

  return (
    <RoomContext.Provider
      value={{ rooms, adults, setAdults, kids, setKids, handleClick, loading }}
    >
      {children}
    </RoomContext.Provider>
  );
};

export default RoomProvider;
